<template>
  <v-list
    dense
    two-line
  >
    <v-list-group append-icon>
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title class="title">{{ $t('Discounts') }}</v-list-tile-title>
        </v-list-tile-content>

        <v-icon v-if="order.summary.total_discount.amount > 0">keyboard_arrow_down</v-icon>

        <v-list-tile-action>
          <v-chip
            small
            color="primary"
            dark
          >
            - {{ order.summary.total_discount | money }}
          </v-chip>
        </v-list-tile-action>
      </v-list-tile>

      <template v-if="order.summary.total_discount.amount > 0">
        <div class="mx-2">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="subheading">
                {{ $t('Items Discount') }}
              </v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action class="subheading">
              -{{ order.summary.total_items_discount | money }}
            </v-list-tile-action>
          </v-list-tile>
        </div>

        <order-discount-breakdown
          v-for="(item) of order.items"
          :discounts="item.discounts"
          :key="item.id"
          class="mx-4"
        />

        <template v-if="order.summary.total_shipping_discount.amount > 0" >
          <v-divider />
          <div class="mx-2">
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="subheading">
                  {{ $t('Shipping Discount') }}
                </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action class="subheading">
                -{{ order.summary.total_shipping_discount | money }}
              </v-list-tile-action>
            </v-list-tile>
          </div>

          <order-discount-breakdown
            :discounts="order.shipping.discounts"
            class="mx-4"
          />
        </template>
      </template>
    </v-list-group>
  </v-list>
</template>

<script>
import OrderDiscountBreakdown from './OrderSingleDiscount/OrderDiscountBreakdown'
import OrderDiscountTotal from './OrderSingleDiscount/OrderDiscountTotal'

export default {
  name: 'OrderSingleSummaryDiscounts',

  components: { OrderDiscountTotal, OrderDiscountBreakdown },
  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>
